// src/features/procedures/components/steps/TextInputStep.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';

/**
 * Text Input Step Component
 * 
 * Validation Rules Config:
 * {
 *   "min_length": 10,        // Minimum character length
 *   "max_length": 2000,      // Maximum character length
 *   "pattern": "^[A-Z].*",   // Regex pattern (optional)
 *   "pattern_message": "Must start with capital letter" // Custom error message
 * }
 */
export default function TextInputStep({ step, value, onChange, disabled, preview }) {
  const { t } = useTranslation(['procedures']);
  const validationRules = step.validation_rules || {};
  const minLength = validationRules.min_length || 0;
  const maxLength = validationRules.max_length || 5000;

  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // Validate pattern if provided
    if (validationRules.pattern && newValue) {
      const regex = new RegExp(validationRules.pattern);
      if (!regex.test(newValue)) {
        // You could set an error state here
        console.warn('Pattern validation failed:', validationRules.pattern_message);
      }
    }

    onChange(newValue);
  };

  return (
    <TextField
      fullWidth
      multiline
      minRows={3}
      maxRows={12}
      placeholder={t('procedures:text_input.placeholder', 'Skriv her...')}
      // Only mention the limit once it's getting close
      helperText={(value || '').length > maxLength * 0.8 ? `${(value || '').length}/${maxLength}` : undefined}
      value={value || ''}
      onChange={handleChange}
      disabled={disabled || preview}
      required={step.is_required}
      inputProps={{
        minLength: minLength,
        maxLength: maxLength,
      }}
    />
  );
}